import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { FilterIds } from 'swag-common/constants/main-swag.constants';
import { isAvailableSuperSpeedSelector } from 'swag-client-common/redux/settings/settings.selectors';
import { isCuratedBrandStoreSelector } from '../../../../../../../redux/curated-brand-store/curated-brand-store-other.selector';
import { BoxAndInventoryComponent } from './box-and-inventory';
const getValue = (defaultValue, filterData, filterId) => {
  return defaultValue !== null && defaultValue !== void 0 ? defaultValue : filterData.find(({
    id
  }) => id === filterId).value;
};
const propsSelector = (_, props) => props;
const filtersSelector = createSelector(propsSelector, ({
  filterData,
  isBoxSelected,
  isInventorySelected,
  isSuperSpeedSelected
}) => {
  const isSuperSpeed = getValue(isSuperSpeedSelected, filterData, FilterIds.isSuperSpeed);
  return {
    isBox: isSuperSpeed ? true : getValue(isBoxSelected, filterData, FilterIds.isBox),
    isInventory: getValue(isInventorySelected, filterData, FilterIds.isInventory),
    isSuperSpeed
  };
});
const mapStateToProps = createStructuredSelector({
  isAvailableSuperSpeed: isAvailableSuperSpeedSelector,
  isCuratedBrandStore: isCuratedBrandStoreSelector,
  filters: filtersSelector
});
export const BoxAndInventory = connect(mapStateToProps)(BoxAndInventoryComponent);